import BrowserPrint from './BrowserPrint.js';
class ZebraPrinterManager {
  constructor() {
    this.BrowserPrint    = BrowserPrint();
    this.localPrinters   = [];
    this.networkPrinters = [];
    this.selectedPrinter = null;
    this._canPrint       = false;
    this.errorMessage    = '';
    this.printHeader     = "^XA^LL200^FO80,50^A0N36,36^FD";
    this.printFooter     = "^FS^XZ";
  }

  init(callback) {
    this.getPrinters((printers) => {
      if (printers && Object.values(printers).length) {
        Object.values(printers).map(printer => {
          if (printer.connection === 'usb') this.localPrinters.push(printer);
          else this.networkPrinters.push(printer);
        });

        this.getDefaultPrinter((printer) => {
          if (printer) {
            this.selectedPrinter = printer;
            this._canPrint = true;
            this.errorMessage = '';
          } else {
            this._canPrint = false;
            this.errorMessage = 'Не установлен стандартный принтер.';
          }
          if (callback && typeof callback === 'function') callback(this._canPrint, this.errorMessage);
        });
      } else {
        this._canPrint = false;
        this.errorMessage = 'Принтеры не обнаружены, проверьте подключение принтера.';
        if (callback && typeof callback === 'function') callback(this._canPrint, this.errorMessage);
      }
    });
  }

  setHeader(text) {
    if (text && text.length) this.printHeader = text;
  }

  setFooter(text) {
    if (text && text.length) this.printFooter = text;
  }

  canPrint(callback) {
    if (!this.selectedPrinter) callback(false, 'Неизвестная ошибка, проверьте исправность и подключение принтера');
    else this.selectedPrinter.sendThenRead("~HQES", text => {
      let statuses = [], ok = false, is_error = text.charAt(70),
      media = text.charAt(88), head = text.charAt(87), pause = text.charAt(84);

      // check each flag that prevents printing
      if (parseInt(is_error) === 0) {
        ok = true;
        statuses.push("Ready to Print");
      }

      switch (parseInt(media)) {
        case 1: statuses.push("Проверьте ленту принтера"); break;
        case 2: statuses.push("Проверьте ленту принтера"); break;
        case 4: statuses.push("Открыта крышка принтера"); break;
        case 8: statuses.push("Проверьте резак принтера"); break;
      }

      switch (parseInt(head)) {
        case 1: statuses.push("Перегрев печатающей головки принтера"); break;
        case 2: statuses.push("Перегрев двигателя принтера"); break;
        case 4: statuses.push("Ошибка печатающей головки, проверьте приентер"); break;
        case 8: statuses.push("Неверная печатающая головка, проверьте принтер"); break;
      }

      if (parseInt(pause) === 1) {
        statuses.push("Принтер находится в режиме паузы");
        ok = false;
      }
      if (!ok && statuses.length === 0) statuses.push("Неизвестная ошибка, проверьте исправность и подключение принтера");

      callback(ok, statuses.join(', '));
    }, errorText => callback(false, errorText));
  }

  getPrinters(callback) {
    this.BrowserPrint.getLocalDevices(printers => callback(printers));
  }

  getDefaultPrinter(callback) {
    this.BrowserPrint.getDefaultDevice('printer', printer => callback(printer));
  }

  print(text, callback) {
    this.canPrint((status, message) => {
      if (status) {
        this.selectedPrinter.send(
          this.printHeader + text + this.printFooter,
          message => callback(true, message),
          message => callback(false, message)
        );
      } else callback(status, message);
    });
  }

}

export { ZebraPrinterManager as default};



// WEBPACK FOOTER //
// ./src/assets/js/print/ZebraPrinterManager.js